/* eslint-disable react/jsx-props-no-spreading */
import { ITemplateInfoView } from 'apis/models';
import Preview from 'components/Preview';
import PreviewIframe from 'components/PreviewIframe';
import { Modal } from 'm-ui';
import React from 'react';
import ReactDOM from 'react-dom';

export const show = (config: any, content: any) => {
  let currentConfig = { ...config, visible: true };
  const div = document.createElement('div');
  div.id = 'preview';
  document.body.appendChild(div);
  const render = ({ content, ...props }: any) => {
    setTimeout(() => {
      ReactDOM.render(
        <Modal
          {...props}
          onOk={() => {
            close();
            props?.onOk?.();
          }}
          onCancel={() => {
            close();
            props?.onCancel?.();
          }}
        >
          {content}
        </Modal>,
        div,
      );
    });
  };
  const close = () => {
    currentConfig = {
      ...currentConfig,
      visible: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }
        div.parentNode?.removeChild(div);
      },
    };
    render(currentConfig);
  };
  render({ ...currentConfig, content });
};

export const showPreview = (config: ITemplateInfoView, success?: () => void) => {
  const modalConfig = {
    title: '模板详情',
    okText: '使用模板',
    cancelText: '取消',
    width: '736px',
    onOk: success,
    destroyOnClose: true,
    bodyStyle: {
      padding: '24px 40px',
    },
    cancelButtonProps: {
      style: {
        width: '88px',
      },
    },
  };
  return show(modalConfig, <Preview record={config} />);
};

export const showPreviewIframe = (src: string, schema: string) => {
  const modalConfig = {
    title: null,
    width: '270px',
    footer: null,
    className: 'dialog-preview-iframe',
    bodyStyle: { padding: '0', borderRadius: '18px' },
    style: {
      borderRadius: '18px',
      paddingBottom: 0,
    },
    destroyOnClose: true,
  };
  // 后端下发的url错误，前端临时处理改。
  const url = src.split('?')[0];
  const search = src.split('?')[1];
  const newSearch = new URLSearchParams(search);
  newSearch.delete('projectId');
  newSearch.delete('version');
  newSearch.set('config', schema);
  const newSrc = `${url}?${newSearch.toString()}`;
  return show(modalConfig, <PreviewIframe width={250} height={444} src={newSrc} />);
};
